import { KYCSTATUS, STAGE, SUBSTAGE } from "../constants";

 
export const ERROR_TYPES= {
  NAME_MISMATCH_ERROR: "NAME_MISMATCH_ERROR",
  FACE_MISMATCH_ERROR: "FACE_MISMATCH_ERROR",
  SESSION_EXPIRED: "SESSION_EXPIRED",
  ATTEMPT_ERROR: "ATTEMPT_ERROR",
  INVALID_ACCOUNT_DETAILS: "INVALID_ACCOUNT_DETAILS",
  ONE_MONEY_CONSENT: "ONE_MONEY_CONSENT",
  TEMPORARY_SERVER_ERROR: "TEMPORARY_SERVER_ERROR", 
  [KYCSTATUS?.PAN_KYC_NAME_MATCH_CREDIT_QUEUE]: KYCSTATUS?.PAN_KYC_NAME_MATCH_CREDIT_QUEUE,
  [SUBSTAGE?.KYC_BANK_NAME_MATCH_CREDIT_QUEUE]: SUBSTAGE?.KYC_BANK_NAME_MATCH_CREDIT_QUEUE,
  [SUBSTAGE?.DIGI_KYC_FAIL_FACEMATCH]: SUBSTAGE?.DIGI_KYC_FAIL_FACEMATCH,
  [SUBSTAGE?.MANDATE_LIMIT_EXHAUSTED]: SUBSTAGE?.MANDATE_LIMIT_EXHAUSTED,
  [STAGE?.CLOSED]: STAGE?.CLOSED,
  [STAGE?.CREDIT_QUEUE]: STAGE?.CREDIT_QUEUE,
}